import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils
import axios from '../../utils/axios';
import { receiverData } from '../../@types/receiversData';
import URLConstants from 'constants/urlConstants';

type ReceiversOfCustomerState = {
    isLoading: boolean;
    error: boolean;
    receiversOfCustomer: receiverData[];
}

const initialState: ReceiversOfCustomerState = {
    isLoading: false,
    error: false,
    receiversOfCustomer: [],
}

const slice = createSlice({
    name: 'ReceiversOfCustomers',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // GET RECEIVERS OF A CUSTOMER
        getReceiversOfCustomerSuccess(state, action) {
            state.isLoading = false;
            state.receiversOfCustomer = action.payload;
        },
    }
});

// Reducer
export default slice.reducer;


export function getReceiversOfCustomer(userId: number) {
    return async () => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.get(`https://6jfjr9vffh.execute-api.ap-south-1.amazonaws.com/staging/mcus/bo/receiver/${userId}`);
        dispatch(slice.actions.getReceiversOfCustomerSuccess(response.data.data));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
  }